const TrashIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="21" fill="none" viewBox="0 0 24 21">
  <g clip-path="url(#a)" opacity=".5">
    <path fill="#1A1A1A" d="M17.778 20.5H6.223c-1.216 0-2.241-.876-2.383-2.038l-.001-.01L2.405 5.195c-.046-.422.273-.8.713-.845.439-.044.833.263.878.686l1.434 13.25a.79.79 0 0 0 .794.675h11.554a.79.79 0 0 0 .794-.674l1.433-13.25c.046-.424.44-.73.879-.687.44.044.758.423.713.845l-1.434 13.257v.01c-.143 1.163-1.168 2.038-2.384 2.038h-.001Z" />
    <path fill="#1A1A1A" d="M22.4 5.885H1.6c-.883 0-1.6-.69-1.6-1.539V2.038C0 1.19.718.5 1.6.5h20.8c.882 0 1.6.69 1.6 1.538v2.308c0 .849-.718 1.539-1.6 1.539ZM1.6 2.038h-.001L1.6 4.346h20.8V2.038H1.6Zm13.2 13.847a.813.813 0 0 1-.566-.226L12 13.511l-2.235 2.148c-.312.3-.819.3-1.131 0a.749.749 0 0 1 0-1.088l2.234-2.148-2.234-2.149a.748.748 0 0 1 0-1.088c.312-.3.819-.3 1.131 0L12 11.335l2.234-2.149c.313-.3.82-.3 1.132 0a.75.75 0 0 1 0 1.088l-2.235 2.149 2.235 2.148a.75.75 0 0 1 0 1.088.815.815 0 0 1-.566.226Z" />
  </g>
  <defs>
    <clipPath id="a">
      <path fill="#fff" d="M0 .5h24v20H0z" />
    </clipPath>
  </defs>
</svg>




export default TrashIcon;
